import apiClient from "@/services/api-client";
import type { PlatformSetting } from "@/types";

export const settingsService = {
  list: async () => {
    const response = await apiClient.get<PlatformSetting[]>("/settings");
    return response.data;
  },
  create: async (payload: {
    key: string;
    value: string;
    description?: string;
    valueType: PlatformSetting["valueType"];
    scope: string;
    environment: string;
    isSecret?: boolean;
    validation?: Record<string, unknown>;
    changeNote: string;
  }) => {
    const response = await apiClient.post<PlatformSetting>(
      "/settings",
      payload,
    );
    return response.data;
  },
  update: async (
    key: string,
    payload: { value?: string; description?: string; changeNote: string },
  ) => {
    const response = await apiClient.patch<PlatformSetting>(
      `/settings/${key}`,
      payload,
    );
    return response.data;
  },
  publish: async (key: string, version: number, reason: string) => {
    const response = await apiClient.post(
      `/settings/${encodeURIComponent(key)}/versions/${version}/publish`,
      { reason },
    );
    return response.data;
  },
  rollback: async (key: string, version: number, reason: string) => {
    const response = await apiClient.post(
      `/settings/${encodeURIComponent(key)}/versions/${version}/rollback`,
      { reason },
    );
    return response.data;
  },
};
